<template>
    <div>
        <v-row>
            <v-col cols="12">
                <v-expansion-panels 
                v-if="prop_qsts_submission!=undefined && prop_qsts_submission.length!=0" 
                v-model="data_open_all_panels"
                v-bind:inset="true"
                v-bind:multiple="true"
                v-bind:focusable="true">
                    <v-expansion-panel 
                    v-for="qsts_section in prop_qsts_submission[0].qsts_sectioned" 
                    v-bind:key="qsts_section.info.id"
                    v-bind:id="qsts_section.info.id">
                        <v-expansion-panel-header class="text-center text-white app-class-summary-panel-headings">
                            <h4>
                                <strong>
                                    {{qsts_section.info.name.split(".")[1]}}
                                </strong>
                            </h4>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-simple-table>
                                <template v-slot:default>
                                    <tbody>
                                        <tr>
                                            <td class="text-left">
                                                <strong>Max-Score : {{qsts_section.score.max}}</strong>
                                            </td>
                                            <td class="text-right">
                                                <strong>Obtained-Score : {{qsts_section.score.total}}</strong>
                                            </td>
                                        </tr>
                                        <tr v-for="(qst,index) in qsts_section.qsts" :key="index">
                                            <td v-if="qst.sub_section_header!=undefined" class="app-class-section-headings text-left">
                                                <strong>{{qst.sub_section_header}}</strong>
                                            </td>
                                            <td v-else class="text-left">
                                                <v-btn 
                                                icon
                                                color="success" 
                                                @click="meth_view_question_detail(qst)">
                                                    <v-icon>mdi-information-variant</v-icon>
                                                </v-btn> 
                                                {{ qst.question }}
                                            </td>
                                            <td class="text-right">
                                                <p v-if="qst.input_type=='img'">
                                                    <ComponentImageLinks 
                                                    prop_image_alt_text=""
                                                    v-bind:prop_image_url_size_medium="meth_generate_img_link(qst).img_links.medium" 
                                                    v-bind:prop_image_url_size_small="meth_generate_img_link(qst).img_links.small"/>
                                                </p>
                                                <p v-else>
                                                    <span v-for="opt in qst.selected_options" v-bind:key="opt.name">
                                                        {{opt.name}}
                                                    </span>
                                                </p>
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12">
                <v-dialog 
                v-model="data_dialog_qst_detail" 
                scrollable 
                max-width="600px">
                    <v-card>
                        <v-card-title class="headline bg-light">
                            <p class="text-center" v-if="data_selected_qst!=undefined||data_selected_qst!=null">
                                {{data_selected_qst.question}}
                            </p>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text v-if="data_selected_qst!=undefined||data_selected_qst!=null">
                            <div v-if="data_selected_qst.input_type=='img'">
                                <h4 class="text-center">Qst Type : Media</h4>
                                <v-divider></v-divider>
                                <p class="text-center">
                                    <ComponentImageLinks 
                                    prop_image_alt_text=""
                                    v-bind:prop_image_url_size_medium="meth_generate_img_link(data_selected_qst).img_links.medium" 
                                    v-bind:prop_image_url_size_small="meth_generate_img_link(data_selected_qst).img_links.small"/>
                                </p>
                            </div>
                            <div v-else-if="data_selected_qst.input_type=='text'">
                                <h4 class="text-center">Qst Type : Input</h4>
                                <v-divider></v-divider>
                                <p v-for="opt in data_selected_qst.selected_options" v-bind:key="opt.name" 
                                class="text-center">
                                    <strong>{{opt.name}}</strong>
                                </p>
                            </div>
                            <div v-else-if="data_selected_qst.input_type=='num'">
                                <h4 class="text-center">Qst Type : Input</h4>
                                <v-divider></v-divider>
                                <p v-for="opt in data_selected_qst.selected_options" v-bind:key="opt.name" 
                                class="text-center">
                                    <strong>{{opt.name}}</strong>
                                </p>
                            </div>
                            <!-- single and multi-choice -->
                            <div v-else>
                                <h4 class="text-center">
                                    Qst Type : Choice({{data_selected_qst.input_type}})
                                </h4>
                                <v-divider></v-divider>
                                <v-row >
                                    <v-col xs="12" sm="12" md="6" lg="6">
                                        <h4>Options</h4>
                                        <div v-for="available_opt in data_selected_qst.options" v-bind:key="available_opt.name" 
                                        class="alert alert-success">
                                            <p>Value: <strong>{{available_opt.name}}</strong></p>
                                            <p>Score: <strong>{{available_opt.weight}}</strong></p>
                                        </div>
                                    </v-col>
                                    <v-col xs="12" sm="12" md="6" lg="6">
                                        <h4>Answer</h4>
                                        <div v-for="selected_opt in data_selected_qst.selected_options" v-bind:key="selected_opt.name" 
                                        class="alert alert-info">
                                            <p>Value: <strong>{{selected_opt.name}}</strong></p>
                                            <p>Score: <strong>{{selected_opt.weight}}</strong></p>
                                        </div>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn 
                            icon
                            color="error" 
                            @click="data_dialog_qst_detail=false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-col>
        </v-row>
    </div>
</template>

<script>
//########################################
//IMPORTS libs
//########################################

import {Facades_Apps_Urls} from '@/libs/links/links_to_pages.js';

//########################################
//IMPORTS components
//########################################

//GENERIC COMPONENTS
import ComponentImageLinks from '@/components/ComponentImageLinks';

//########################################
//MAIN
//########################################
export default {
    name: 'ComponentSectionDetails',

    components:{
        ComponentImageLinks
    },

    props:[
        'prop_qsts_submission',
    ],

    methods:{
        meth_generate_img_link:function(param_qst_obj)
        {
            return helper_generate_qst_img_links.call(this,param_qst_obj);
        },

        meth_view_question_detail:function(param_qst_obj)
        {
            //close the dialog for a questin detail
            this.data_dialog_qst_detail=true

            this.data_selected_qst=param_qst_obj
        },
    },

    data: function()
    {
        return {
            data_selected_qst:null,

            data_dialog_qst_detail:false
        }
    },

    computed:{
        data_open_all_panels:function()
        {
            let all_panels_index=[]

            if(this.prop_qsts_submission!=undefined && this.prop_qsts_submission.length!=0)
            {
                this.prop_qsts_submission[0].qsts_sectioned.map(
                    function(qst_sec,qst_sec_index)
                    {
                        all_panels_index.push(qst_sec_index)
                    }
                )
            }

            return all_panels_index
        }
    }
}

//call all with signature func_imp.call(this,param_1,param_2)
//############################################
//HELPERS
//############################################
/**
 * check the link-ref is not undefined
 */
function helper_generate_qst_img_links(param_qst_obj)
{
    //OBJ CONTEXT
    var self=this;

    if(param_qst_obj!==undefined)
    {
        let gen_img_links=Facades_Apps_Urls.fmoh_iss_gen_img_link(
            self.$route.params.username,
            self.$route.params.form_id,
            self.$route.params.form_name,
            param_qst_obj.selected_options[0].name
        );
        return{
            img_links:gen_img_links,
            qst:param_qst_obj.question
        };
    }
    else
    {
        let gen_img_links=Facades_Apps_Urls.fmoh_iss_gen_img_link("not_answered");
        return{
            img_links:gen_img_links,
            qst:undefined
        };
    }
}

//############################################
//API_REQUESTS
//############################################

//############################################
//DATA_OPPS
//############################################

//############################################
//ACTIONS
//############################################
</script>
